import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { empresasColumns } from './columns/_columns'
import { EmpresaList } from '../../../empresa/empresas-list/core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const EmpresasTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => empresasColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhuma ${t('empresa.label.lowercase')} encontrada para “${filters.empresa.trim()}”`}
      description='Revise o termo digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title={`Nenhuma ${t('empresa.label.lowercase')} cadastrada`}
      description={`As ${t(
        'empresa.plural.lowercase'
      )} aparecem aqui para gerar token e configurar webhook.`}
    />
  )

  return (
    <CustomTable<EmpresaList>
      id='kt_table_empresas_auth'
      ariaLabel={`${t('empresa.plural')} — integração por API`}
      itemLabel={{
        singular: t('empresa.label.lowercase'),
        plural: t('empresa.plural.lowercase'),
      }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
